import React, { useEffect, useState } from "react";
import brandImage from "../../static/images/brand.png";
import sabotonLogo2 from "../../static/svg/logo-saboten-2.png";
import hibarinLogo2 from "../../static/svg/logo-hibarin-2.png";
import tacobellLogo from "../../static/svg/logo-tacobell-2.svg";
import { Link, useLocation } from "react-router-dom";
import Footer from "../Footer";
import ModalProvider from "./modal/modal-provider";
import BrandModal from "./modal/BrandModal";
import CentralCircle from "./circle/CentralCircle";
import ReperkCircle from "./circle/ReperkCircle";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function BrandList() {
  const query = useQuery();
  const [parameter, setParameter] = useState("");
  useEffect(() => {
    const urlParameter = query.get("modal");
    setParameter(urlParameter);
  }, [query]);

  return (
    <>
      <div className="viewport-wrapper">
        <div className="main-bg-wrapper">
          <div className="brand-list-wrapper">
            <Link
              className="d-inline-block brand-circle-wrapper saboten animate__animated animate__rotateIn"
              to="/brand/saboten/story"
            >
              <div className="brand-logo-wrapper">
                <img src={sabotonLogo2} alt="saboten logo" />
              </div>
              <div className="brand-title">사보텐</div>
            </Link>
            <Link
              className="d-inline-block brand-circle-wrapper hibarin animate__animated animate__rotateIn"
              to="/brand/hibarin/story"
            >
              <div className="brand-logo-wrapper">
                <img src={hibarinLogo2} alt="hibarin logo" />
              </div>
              <div className="brand-title">히바린</div>
            </Link>
            <a
              className="d-inline-block brand-circle-wrapper tacobell animate__animated animate__rotateIn"
              href="http://koreatacobell.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <div className="brand-logo-wrapper">
                <img src={tacobellLogo} alt="taco bell logo" />
              </div>
              <div className="brand-title">타코벨</div>
            </a>
            {/* <CentralCircle parameter={parameter} /> */}
            <ReperkCircle parameter={parameter} />
          </div>
        </div>
        <div className="wh-100">
          <img src={brandImage} alt="brand bg" className="img-fill" />
        </div>
      </div>
      <Footer />
      <BrandModal />
    </>
  );
}

export default BrandList;
